import { createAsyncThunk } from '@reduxjs/toolkit';
import { TripEntity } from '@interpals/api-web';

import api from 'api';

export const fetchTrips = createAsyncThunk<TripEntity[], string>('trips/fetch', async (id) => {
    return (await api.getUserTrips({ id })).data;
});

interface CreateUpdateTripParams {
    startDate: string;
    endDate: string;
    cityId: string;
    description?: string;
}

export const createTrip = createAsyncThunk<TripEntity, CreateUpdateTripParams>('trips/create', async (tripData) => {
    return api.createTrip({
        start_date: tripData.startDate,
        end_date: tripData.endDate,
        city_id: tripData.cityId,
        description: tripData.description,
    });
});

// TODO: Backend errors.
export const editTrip = createAsyncThunk<
    TripEntity,
    CreateUpdateTripParams & {
        id: string;
    }
>('trips/update', async (tripData) => {
    return await api.updateTripById({
        id: tripData.id,
        start_date: tripData.startDate,
        end_date: tripData.endDate,
        city_id: tripData.cityId,
        description: tripData.description,
    });
});

export const deleteTrip = createAsyncThunk('trips/delete', async (id: string) => {
    await api.deleteTrip({ id });

    return id;
});
